<template>
  <v-container class="max-container">
      <v-row class="flex-row-center">
        <v-col xs="12" sm="12" md="6" lg="6" class="flex-col-center">
            <v-img :contain="!!offerObject.image" height="45vh" width="45vh" :src="offerObject.image ? offerObject.image : imgDefault"/>
            <div class="flex-row-center tags__div w-100">
                <div class="tags" :style="{'background-color': currentCompany.buttonsColor}">Economize {{ 'R$' + offerObject.discountValue.toFixed(2).toString().replace(".", ",")}}</div>
                <div class="tags" :style="{'background-color': currentCompany.buttonsColor}">{{ (offerObject.discountPercent) + '%' }} OFF</div>
            </div>          
        </v-col>
        <v-col xs="12" sm="8" md="5" lg="5" class="flex-col-center">
            <v-card class="offer_card">
                <v-card-title class="flex-row-center no-pd-b" >
                  <div class="text-truncate" style="max-width: 330px;">
                    <strong class="product_name">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <span v-on="on"> {{ offerObject.name}}</span>
                            </template>
                              {{ offerObject.name}}
                        </v-tooltip>
                    </strong>
                  </div>
                    
                </v-card-title>
                <v-card-text class="flex-col-center">
                    <div class="flex-row-start">
                      <div class="old-price"><strike>{{ 'R$' + offerObject.price.toFixed(2).toString().replace(".", ",") }}</strike></div>
                      <div class="current-price">{{ 'R$' +  offerObject.discountedPrice.toFixed(2).toString().replace(".", ",") }}</div> 
                    </div>                    
                    <div v-show="offerObject.maxRedeems">
                        <span>
                            <strong>Disponível: </strong>
                            {{offerObject.maxRedeems}}
                        </span> 
                    </div>
                    <div class="divider_line"></div>  
                    <div>
                        <v-btn v-if="!offerObject.activated && currentCompany.integrated" class="text-none button-activate text-white" :loading="btnLoading" :color="currentCompany.primaryColor" @click="activate()">
                            <span class="text-white">Ativar desconto</span>
                        </v-btn>
                        <div v-if="offerObject.activated && currentCompany.integrated" class="flex-col-center">
                            <strong class="discount-active__title" :style="{'color': currentCompany.primaryColor}">Desconto ativado! Agora siga as instruções:</strong>
                            <div class="discount-active__item"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">1.</span>  Leve seus produtos até o caixa;</div>
                            <div class="discount-active__item"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">2.</span> Se identifique no caixa através do seu {{punctationType}};</div>
                            <div class="discount-active__item"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">3.</span> Receba o desconto ativado;</div>
                        </div>
                        <div v-if="!currentCompany.integrated" class="flex-col-center">
                            <strong class="discount-active__title" :style="{'color': currentCompany.primaryColor}">Instruções para ativar desconto:</strong>
                            <div class="discount-active__item"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">1.</span>  Leve seus produtos até o caixa;</div>
                            <div class="discount-active__item"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">2.</span> Se identifique no caixa através do seu {{punctationType}};</div>
                            <div class="discount-active__item--weight"> <span :style="{'color': currentCompany.primaryColor, 'font-weight': '700'}">3.</span> Solicite o resgate ao atendente.</div>
                        </div>
                        <div class="flex-col-center" v-if="offerObject.dateEnd">
                            <span class="cardtext-expiring-date">{{'Expira em ' + getDateByTimeStamp( offerObject.dateEnd ) + ' ' + getHourByTimeStamp( offerObject.dateEnd)}}</span>
                        </div>
                    </div> 
                </v-card-text>
            </v-card>
        </v-col>
        <v-col xs="12" sm="8" md="9" lg="9" class="flex-col-start">
            <div class="flex-col-start w-100">
                <div class="flex-row-start">
                    <strong>Limite por pessoa:</strong>
                    <span style="margin-left: 10px">{{ offerObject.maxPersonalRedeems ? offerObject.maxPersonalRedeems : 'Ilimitado' }}</span>
                </div>
            </div>            
        </v-col>
      </v-row>
      
  </v-container>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getProductByIdAndCompanyIdAndCurrentContactId, activateOfferProductByIdAndCompanyIdAndCurrentContactId } from "@/app/components/offer-detail/service/offer-detail-service";
import { getCompanyLoyaltyByCompanyId } from "@/app/modals/rules-modal/service/rules-modal.service";

//Components
import ConfirmRescueModal from "@/app/modals/confirm-rescue-modal/confirm-rescue-modal"

export default {
    name: "Offer-detail",
    components: { ConfirmRescueModal },
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany'
        })
    },
    data: () => ({
        participantIdLocal: null,
        offerObject: {
            name: "-",
            image: '-',
            price: '-', 
            offerPrice: '-',
            activated: false,
            description: "-",
            limitPerContact: "-",
            percentage: '-',
            punctationType: '-'
        },
        btnLoading: false,
        imgDefault: require('@/assets/empty_ofertas.svg')
    }),
    created(){
        this.getAllScreenInfo()
        this.getPunctationForm()
    },
    methods: {
        getAllScreenInfo(){
            this.participantIdLocal = this.$route.query.participantId
            getProductByIdAndCompanyIdAndCurrentContactId(this.currentCompany.id, this.participantIdLocal)
            .then( success => {
                this.offerObject = success.data
            })
            .catch( error => error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '' )
        },
        activate(){
            this.btnLoading = true
            activateOfferProductByIdAndCompanyIdAndCurrentContactId(this.currentCompany.id, this.participantIdLocal)
            .then(() => {
                this.btnLoading = false;
                this.offerObject.activated = true;
                this.$forceUpdate()
            })
            .catch( error => {
                error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '' 
                this.btnLoading = false
            })            
        },
        getPunctationForm() {
            getCompanyLoyaltyByCompanyId(this.currentCompany.id)
                .then( success => {
                        success.data.inputTypeId == 1 ? this.punctationType = 'Telefone' : success.data.inputTypeId == 2 ? this.punctationType = 'CPF' : ''
                    }
                )
        },
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        }
    }
}
</script>

<style scoped>
.tags__div{
    margin-top: 45px !important;
}
.tags{
    color: white;
    padding: 5px 15px;
    border-radius: 5px;
    text-align: center;
    margin-right: 15px;
}
.offer_card{
    margin: 20px;
    width: 100%;
    border-radius: 15px !important;
}
.divider_line{
    width: 100%; 
    border-bottom: 1px solid lightgray;
    margin-top: 20px;
    margin-bottom: 20px;
}
.old-price{
    font-size: 20px;
}
.current-price{
    margin: 10px;
    font-size: 30px;
    font-weight: 700;
    color: var(--cor--verde)
}
.button-activate{
    padding: 10px;
    width: 300px;
    border-radius: 8px;
    height: 40px !important;
}
.discount-active__title{
    font-size: 16px;
    margin-bottom: 10px;
}
.discount-active__item{
    font-size: 16px;
    color: gray;
}
.discount-active__item--weight {
    font-size: 16px;
    color: gray;
    font-weight: bold;
}
.expires-text{
    margin-top: 15px;
    font-size: 18px;
    font-weight: 800;
}
.bottom-description{
    margin-bottom: 15px;;
}
.cardtext-expiring-date {
    font-size: 16px;
    font-weight: 900;
    color: var(--cor--azul--escuro);
    margin-top: 10px;
}
</style>